import { graphql, useStaticQuery } from 'gatsby';

const useEmpleo = () => {

    const data = useStaticQuery(graphql`
        query {
            allDatoCmsEmpleo(filter: {}) {
                nodes {
                  titulo,
                  anio,
                  descripcion
                }
            }
        }
    `);

    return data.allDatoCmsEmpleo.nodes.map(empleo => ({
        titulo: empleo.titulo,
        anio: empleo.anio,
        descripcion: empleo.descripcion
    }));
}
 
export default useEmpleo;